import {createSlice} from "@reduxjs/toolkit";
import {UserRoles} from "../../shared/types";

interface IState {
  userId: null | string,
  token: null | string,
  userRole: null | UserRoles,
  userName: null | string,
}

const initialState: IState = {
  userId: null,
  token: null,
  userRole: null,
  userName: null,
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    auth: (state, action) => {
      state.userId = action.payload.userId
      state.token = action.payload.token
    },
    setRole: (state, action) => {
      state.userRole = action.payload.userRole
    },
    setUserName: (state, action) => {
      state.userName = action.payload.userName
    },
  }
})

export const {auth, setRole, setUserName} = authSlice.actions

export default authSlice.reducer